export const Haspermision = ({component,permssion}) =>{
    let permssions = JSON.parse(localStorage.getItem('permissons')); 
    const isavailabale = permssions.filter(value => value.name == permssion);
     
    console.log(isavailabale);
   
    return(
        isavailabale.length <= 0 ?  (<></>) : 
         <>
            {component}
         </>
    ); 
}